import styled from 'styled-components'
import CloseLargeIcon from '@8x8/oxygen-icon/icons/CloseLargeIcon'
import { Flex, ColumnFlex } from '~/components/common/containers'

export const ButtonContainer = styled(Flex)`
  margin-top: 10px;
  justify-content: flex-end;
`

export const Container = styled.div`
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  height: auto;
  max-width: 375px;
  margin: 0 auto;
  padding: 16px;
  position: relative;
  text-align: left;
`

export const Error = styled.div`
  margin-top: 8px;
  color: #FF0000;
  text-align: center;
`

export const FieldWrapper = styled.div`
  padding: 10px 10px 11px;
  border: 1px solid #D1DBE8;
  ${({ percent }) => percent ? `width: ${percent}%;` : ''}
`

export const Footer = styled.div`
  color: #000;
  font-size: 13px;
  line-height: 20px;
  margin: 16px 0;
`

export const Label = styled(ColumnFlex)`
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: #1C2025;
  margin-bottom: 4px;
  margin-top: 24px;
`

export const StripeInput = styled.input`
  border: 1px solid #d1dbe8;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  outline: none;
  padding: 8px;
  width: 100%;

  &::placeholder {
    color: #D5DCE3;
  }

  ${props => props.invalid && `
    color: #EB1C26;
  `}
`

export const StyledCloseLargeIcon = styled(CloseLargeIcon)`
  cursor: pointer;
  margin: auto 0;
`

export const TitleContainer = styled(Flex)`
  justify-content: space-between;
  line-height: 32px;
  margin-bottom: 8px;
`

export const Title = styled.h1`
  color: #1c2025;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin: 0;
  padding: 0;
`

export const ZipCountryPane = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`

export const Subpane = styled(ColumnFlex)`
  min-width: 90px;
`
